import { render, staticRenderFns } from "./RecordDetailsDrawer.vue?vue&type=template&id=f9748cec"
import script from "./RecordDetailsDrawer.vue?vue&type=script&lang=js"
export * from "./RecordDetailsDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports